import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import type { IRelatedLinksProps } from './types';
import './index.scss';
import useLanguage from '@op/hooks/useLanguage';

export default function RelatedLinks({ links }: IRelatedLinksProps) {
  const { formatMessage } = useLanguage();

  if (!Array.isArray(links) || links.length === 0) {
    return null;
  }

  return (
    <div className="dbo-event-detail-links">
      <div className="dbo-event-detail-section__title">
        {formatMessage('Related Links')}
      </div>
      <ul className="dbo-event-detail-links__list">
        {links.map((link, index) => (
          <li key={index} className="dbo-event-detail-links__item">
            <a target='_blank' href={link.url} className="dbo-event-detail-links__anchor" rel="noreferrer">
              <span className="dbo-event-detail-links__title">{link.text}</span>
              <SvgIcon
                type="link-to"
                className="dbo-event-detail-links__arrow"
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
